import { useEffect } from "react";
import { useDispatch, useSelector } from "@grandvisionhq/state";
import { recoverSession } from "../../Login/Login/actions.js";
import { getAuth } from "../../selectors.js";
import { isInitialized, isLoggedIn, AuthState, isLoggedInPasswordless, isParseHashFailed, isLoggedOut } from "../../state.js";
const UNKNOWN = "UNKNOWN";
const useAccount = () => {
  const dispatch = useDispatch();
  const auth = useSelector(getAuth);
  const currentlyInitialized = isInitialized(auth);
  useEffect(() => {
    if (currentlyInitialized) {
      dispatch(recoverSession());
    }
  }, [currentlyInitialized]);
  if (currentlyInitialized) {
    return UNKNOWN;
  }
  if (isLoggedIn(auth)) {
    return AuthState.LoggedIn;
  }
  if (isLoggedInPasswordless(auth) || isParseHashFailed(auth) || isLoggedOut(auth)) {
    return AuthState.LoggedOut;
  }
  return UNKNOWN;
};
export {
  UNKNOWN,
  useAccount
};
//# sourceMappingURL=use-account.js.map
